export default __webpack_public_path__ + "static/media/arrow-right-red.ecf5900f.svg";